import { IArgument } from '@tymely/atoms';

export const CLUSTERING_COMMENT_WORKFLOWS = 'CLUSTERING_COMMENT_WORKFLOWS';
export const DEFAULT_DATASET_PROMPT = 'NEW_CLUSTERING_PROMPT_WISMO';

export const DEFAULT_SUMMARY_PROMPT = 'COMMENTS_SUMMARIZATION_FOR_DECISIONS_CLUSTERING';
export const DEFAULT_CLASSIFICATION_PROMPT = 'COMMENTS_CLASSIFICATION_FOR_DECISIONS_LABELING';
export const DEFAULT_FINAL_LABEL_PROMPT = 'COMMENTS_DECISION_LABELING';

export const LLM_MODEL_ID_GPT = 'openai-responses:gpt-5.2';
export const MODEL_GPT = { id: 1156, llm_model_id: LLM_MODEL_ID_GPT };
export const UNLABELLED = 'Unlabelled';

export const MEDIA_ARGUMENT_DTYPES: IArgument['dtype'][] = [
    'Image',
    'Url',
    'VideoUrl',
    'list[Image]',
    'list[Url]',
    'list[VideoUrl]',
];

export const PRE_FILTER_POLICY_SET_ID = 67;
